export const colors = {
  violetFonce: "#424864",
  violetClair: "#606992",
  rose: "#ec7ca6",
  roseHover: "#bb6886",
  bgGris: "#f5f5f5",
  bgToggle: "#ebecf1",
  black: "#232323",
  blue: "#008bdc",
  blackClair: "#4D4D4D",
  violet: "#862CE0",
  gris: "#929292",
};
